import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { CouponCart } from './couponCart';
import { hideLoader, showLoader } from '@kfc-global/react-shared/redux/Actions/LoaderAction';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  getOfflineCouponsAction,
  setSelectedCoupon,
} from '@kfc-global/react-shared/redux/Actions/OfflineCouponActions';

export const CouponCard = props => {
  const { key, coupon, showConfirmationModal } = props;
  const { SOFT_ONE_TIME_COUPON, ONE_TIME_COUPON } = TRANSLATE_MAPPING_KEY;
  const { StripesLoader } = IMAGE_PATH;
  const selectedCouponId = useSelector(data => data?.offlineCouponsReducer?.selectedCouponId);
  const dispatch = useDispatch();

  return (
    <div key={key} className={`offlineCoupon-card-container ${!!coupon?.timestamp && 'greyedOut'}`}>
      <div className='couponRibbon-container'>
        <div className='angle-down'></div>
        <span className='ribbon-text-svg'>
          {coupon?.sbgCoupon ? translateWithI18Next(ONE_TIME_COUPON) : translateWithI18Next(SOFT_ONE_TIME_COUPON)}
        </span>
      </div>
      <ImageComponent srcFile={coupon?.image} className='offline-coupon-img' alt={'coupon image'} />
      <div className='offlineCoupon-card-content'>
        <div className='offlineCoupon-Card-title'>
          <span className='couponCard-ellipsis-text'>{coupon?.name}</span>
        </div>
        <div className='offlineCoupon-Card-description'>
          <p className='couponCard-ellipsis-text'>{coupon?.description}</p>
        </div>
        {!coupon?.timestamp && (
          <div className='offlineCoupon-redeem-button'>
            {selectedCouponId !== coupon?.couponCode ? (
              <ContainedButton
                data-testid='coupon-redeemid'
                onClickHandler={() => {
                  dispatch(setSelectedCoupon(coupon?.couponCode));
                  showConfirmationModal(true);
                }}
                className='coupon-redeemid'
                variant={ButtonType.secondary}
              >
                {coupon?.button}
              </ContainedButton>
            ) : (
              <img src={StripesLoader} className='reload-icon' alt='Loading' />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
CouponCard.propTypes = {
  key: PropTypes.string,
  coupon: PropTypes.object,
  showConfirmationModal: PropTypes.func,
};

CouponCard.defaultProps = {
  key: '',
  coupon: {},
  showConfirmationModal: null,
};

export const OfflineCoupon = props => {
  const { showConfirmationModal } = props;
  const { NO_COUPONS_AVAILABLE_MESSAGE } = TRANSLATE_MAPPING_KEY;
  const couponsList = useSelector(data => data?.offlineCouponsReducer?.couponsList);
  const isLoading = useSelector(data => data?.offlineCouponsReducer?.isLoading);
  const couponCartList = [];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOfflineCouponsAction());
  }, []);

  useEffect(() => {
    if (isLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isLoading]);

  return (
    <div id='offlineCoupon' className={`offlineCoupon-cards-container ${!!isLoading && 'loading'}`}>
      {couponsList?.length > 0 && Array.isArray(couponsList)
        ? couponsList?.map(coupon => {
            if (coupon?.timestamp) {
              couponCartList.push(coupon);
            }
            return (
              <CouponCard
                key={`couponCard-${coupon?.couponCode}`}
                coupon={coupon}
                showConfirmationModal={showConfirmationModal}
              />
            );
          })
        : !isLoading && (
            <div className='no-coupons-available'>{translateWithI18Next(NO_COUPONS_AVAILABLE_MESSAGE)}</div>
          )}
      {!!couponCartList?.length && <CouponCart itemsList={couponCartList} />}
    </div>
  );
};
OfflineCoupon.propTypes = {
  showConfirmationModal: PropTypes.func,
};
OfflineCoupon.defaultProps = {
  showConfirmationModal: null,
};
